import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Testimonials } from './components/Testimonials';
import { PeekInside } from './components/PeekInside/PeekInside';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';

/**
 * Paid Table Ready landing (DPS-24). Same section order as the 52 Weeks of
 * Barre page. Left out on purpose until real data exists:
 *  - Urgency / countdown (only if the launch offer is real)
 *  - Purchase notifications (need real orders)
 */
type AppProps = {
  /** Auto-advance the Peek Inside carousel every 6s (off for reduced motion). */
  carouselAutoplay?: boolean;
};
export function App({
  carouselAutoplay = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-plum text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3relwynhtxubv">
      <MetaPixel data-id="element-1" data-mp="2zld0746gb58w" />
      <main data-id="element-2" data-mp="2zlv6yuqqp1v2">
        <Hero data-id="element-3" data-mp="2zm4v0cs84yy4" />
        <SocialProofBar data-id="element-4" data-mp="2zmo6pbra6r3p" />
        <PainGrid data-id="element-5" data-mp="2zng0qi58cgrv" />
        <ProductReveal data-id="element-6" data-mp="33mf2jtvnzxf3" />
        <Tomes data-id="element-7" data-mp="33lx18iu5at0b" />
        <PeekInside autoplay={carouselAutoplay} data-id="element-8" data-mp="33ngfy505kvzz" />
        <Testimonials data-id="element-9" data-mp="38lrrqla0dgku" />
        <Bonuses data-id="element-10" data-mp="38li8dgjgy7o4" />
        <ValueStack data-id="element-11" data-mp="38l04pyuh8r66" />
        <Pricing data-id="element-12" data-mp="38kgm0fx05yr3" />
        <Guarantee data-id="element-13" data-mp="38o4fjf2g6l5t" />
        <Faq data-id="element-14" data-mp="3dkl0k0ecojeo" />
        <CostOfInaction data-id="element-15" data-mp="3dl4l7ovdxlwe" />
        <Close data-id="element-16" data-mp="3dmfprqwnmxok" />
      </main>
      <Footer data-id="element-17" data-mp="3dii3wxiozs0z" />
    </div>;
}